<template>
  <b-modal
    ref="modal"
    title="Dati identificazione titolare"
    size="xl"
    class="large"
    centered
    no-close-on-backdrop
  >

    <div class="box mb-3">

      <div class="col-12 box-header">Dati generali</div>
      <div class="row box-body">

        <div
          role="group"
          class="col-12 stack-label"
        >
          <label>Tipo richiesta</label>
          <b-form-select
            v-model="tipoAbl"
            :options="tipoAbilitazioneOptions"
            size="sm"
          />
        </div>

        <div
          role="group"
          class="col-12 col-md-4 stack-label"
        >
          <label>Codice fiscale titolare</label>
          <b-input
            v-model="datiTitolare.codiceFiscale"
            type="text"
            :formatter="formatUcase"
            size="sm"
            :state="fieldState('codiceFiscale')"
          />
          <b-form-invalid-feedback v-if="!$v.datiTitolare.codiceFiscale.required">Campo obbligatorio</b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="!$v.datiTitolare.codiceFiscale.codiceFiscale">Codice fiscale non corretto</b-form-invalid-feedback>
        </div>

        <div
          role="group"
          class="col-12 col-md-3 stack-label"
        >
          <label>Codice RU</label>
          <b-input
            v-model.trim="datiTitolare.codiceRU"
            type="text"
            :formatter="formatUcase"
            trim
            size="sm"
            :state="fieldState('codiceRU')"
          />
          <b-form-invalid-feedback v-if="!$v.datiTitolare.codiceRU.required">Campo obbligatorio</b-form-invalid-feedback>
        </div>

        <div
          role="group"
          class="col-12 col-md-3 stack-label"
        >
          <label>Codice BU</label>
          <b-input
            v-model.trim="datiTitolare.codiceBU"
            type="text"
            :formatter="formatUcase"
            trim
            size="sm"
            :state="fieldState('codiceRU')"
          />
          <b-form-invalid-feedback v-if="!$v.datiTitolare.codiceBU.required">Campo obbligatorio</b-form-invalid-feedback>
        </div>

      </div>
    </div>

    <template slot="modal-footer">

      <!-- <b-button
        v-if="idx===-1"
        variant="success"
        @click="add"
      >
        <font-awesome-icon icon="plus" /> Aggiungi
      </b-button> -->

      <b-button
        variant="success"
        @click="aggiorna"
      >
        <font-awesome-icon icon="edit" /> Crea richiesta
      </b-button>

      <!-- <b-button
        v-if="idx!==-1"
        variant="danger"
        @click="remove"
      >
        <font-awesome-icon
          icon="trash-alt"
          class="mr-2"
        /> Rimuovi componente
      </b-button> -->

      <b-button
        variant="outline-secondary"
        @click="close"
      >
        <font-awesome-icon
          icon="times"
          class="mr-2"
        /> Annulla
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
// import cloneDeep from 'lodash/cloneDeep'
// import CodiceFiscale from '../utils/codice-fiscale'
// import ModelloForm from '@/components/ModelloForm'
// import numeral from 'numeral'
import 'numeral/locales'

// const codiceFiscale = (value, vm) => {
//   if (!value) return true
//   try {
//     let cf1 = CodiceFiscale.computeInverse(value)
//     if (vm.dataNascita) {
//       let dn = vm.dataNascita.split('-')
//       cf1.name = vm.nome
//       cf1.surname = vm.cognome
//       cf1.day = parseInt(dn[2])
//       cf1.month = parseInt(dn[1])
//       cf1.year = parseInt(dn[0])
//       let cf2 = CodiceFiscale.compute(cf1)
//       return cf2.substr(0, 15) === value.toUpperCase().substr(0, 15)
//     }
//     return true
//   } catch (err) {
//     return false
//   }
// }

const codiceFiscale = (value, vm) => {
  var reCF = /[A-Za-z]{6}[0-9lmnpqrstuvLMNPQRSTUV]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9lmnpqrstuvLMNPQRSTUV]{2}[A-Za-z]{1}[0-9lmnpqrstuvLMNPQRSTUV]{3}[A-Za-z]{1}/
  var rePIVA = /[0-9]{11}/
  let retValue = false

  if (value && value.length === 16) {
    if (reCF.test(value)) {
      retValue = true
    }
  } else {
    if (rePIVA.test(value)) {
      retValue = true
    }
  }

  return retValue
}

export default {
  name: 'RichiestaIntermediarioModal',

  data () {
    return {
      // datiTitolare: {},
      datiTitolare: this.emptyTitolare(),
      incaricatoInfo: {},
      idx: -1,
      tipoAbl: 'INC_SPG',
      tipoAbilitazione: [
        { value: 'INC_SPG', text: 'INCARICATO DA SOGGETTI PERSONE GIURIDICHE' }
        // { value: 'INC_NUC', text: 'INCARICATO COMPONENTE NUCLEO FAMILIARE' },
        // { value: 'INC_NDE', text: 'INCARICATO COMPONENTE NUCLEO FAMILIARE IN CASO DI DECESSO ASSEGNATARIO' }
      ],
      lettura: null

    }
  },

  computed: {
    tipoAbilitazioneOptions () {
      return this.tipoAbilitazione
    }

  },

  validations: {
    datiTitolare: {
      // nome: { required },
      // cognome: { required },
      codiceFiscale: { required, codiceFiscale },
      codiceRU: { required },
      codiceBU: { required }
    }
  },

  methods: {
    emptyTitolare () {
      return {
        nome: '',
        cognome: '',
        codiceFiscale: '',
        codiceRU: null,
        codiceBU: null
      }
    },

    // Numero del contratto (RU)
    // Codice dell’immobile (BU)
    // Codice fiscale del titolare dei rapporti su cui si chiede l’abilitazione come (CF)

    fieldState (field) {
      let v = this.$v.datiTitolare[field]
      return v.$dirty && v.$error ? false : null
    },

    async open ({ confermaLettura, titolare, incaricato }) {
      this.$v.$reset()
      // this.item = item
      // let familiare = idx >= 0 ? cloneDeep(item.nuoviFamiliari[idx]) : this.emptyFamiliare()

      this.datiTitolare = titolare
      this.incaricatoInfo = incaricato
      this.lettura = confermaLettura
      // this.datiTitolare = this.emptyTitolare()

      // console.log('visualizza familiare', this.familiare)
      this.$refs.modal.show()
    },

    close () {
      this.$refs.modal.hide()
    },

    validate () {
      this.$v.$touch()
      return !this.$v.$invalid
    },

    async aggiorna () {
      // console.log('spunta Update', this.familiare.legami.matrimonio)
      if (!this.validate()) {
        this.$ui.notify({
          type: 'warning',
          title: 'Attenzione',
          message: 'I dati inseriti non sono corretti.'
        })
      } else {
        // this.familiare.numeroComponente = this.idx + 1
        // this.$set(this.item.nuoviFamiliari, this.idx, this.familiare)

        // Verificare che i dati dei titolare siano coerenti con quanto presente nella base dati (CODICE RU e BU + CF)
        let titolareChecked = await this.$store.dispatch('abilitazioni/checkTitolare', { titolare: this.datiTitolare, tipoAbilitazione: this.tipoAbl })
        // console.log('this.datiTitolare', this.datiTitolare, titolareChecked)

        if (!titolareChecked.verificato) {
          this.$ui.notify({
            type: 'warning',
            title: 'Attenzione',
            message: 'I dati del titolare non sono corretti. Verificare e riprovare.'
          })
        } else {
          // Creare una nuova richiesta di incarico.

          let rs = await this.$store.dispatch('abilitazioni/addNew', { codiceUib: titolareChecked.codiceBu, codiceUtente: titolareChecked.codiceUtente, codiceFiscaleIncaricato: this.incaricatoInfo.codiceFiscale, incaricato: this.incaricatoInfo, confermaLettura: this.lettura })

          // Deve andare sulla pagina relativa al tipo di richiesta selezionato.
          // Ora va solo su incaricati persone giuridiche.

          let incaricato = {}
          // incaricato.nominativo = this.incaricatoInfo.nome + ' ' + this.incaricatoInfo.cognome
          incaricato.nominativo = rs.incaricato.nominativo
          incaricato.codiceFiscale = rs.incaricato.codiceFiscale
          incaricato.cellulare = rs.incaricato.cellulare
          incaricato.email = rs.incaricato.email

          // console.log('Add incarico from landing', rs, this.incaricatoInfo, incaricato)

          this.$router.push({ name: 'incaricoInc', params: { id: rs.id, titolareInfo: titolareChecked, incaricato: incaricato } })
        }

        this.close()
      }
    },

    formatUcase (value, event) {
      return value.toUpperCase()
    }
  }
}

</script>

<style lang="stylus" scoped>
.scrollable {
  max-height: max(20rem, 50vh);
  overflow-y: scroll;
}

.large >>> .modal-xl {
  min-width: 60rem !important;
}
</style>
